import { render, staticRenderFns } from "./FAQDesktop.vue?vue&type=template&id=0cb6f57c&scoped=true&"
import script from "./FAQDesktop.vue?vue&type=script&lang=js&"
export * from "./FAQDesktop.vue?vue&type=script&lang=js&"
import style0 from "./FAQDesktop.vue?vue&type=style&index=0&id=0cb6f57c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb6f57c",
  null
  
)

export default component.exports